import { SliderThumb as MuiSliderThumb } from '@mui/material/Slider';

import { Box, Stack } from '@lyearn/ui';

interface SliderThumbProps extends React.HTMLAttributes<unknown> {}

function SliderThumb(props: SliderThumbProps) {
  const { children, ...other } = props;
  return (
    <MuiSliderThumb {...other}>
      {children}
      <Stack gapX={3}>
        <Box className="h-10 w-2 rounded-full bg-interactive-secondary-active" />
        <Box className="h-10 w-2 rounded-full bg-interactive-secondary-active" />
        <Box className="h-10 w-2 rounded-full bg-interactive-secondary-active" />
      </Stack>
    </MuiSliderThumb>
  );
}

export default SliderThumb;
